import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'mobx-react';
import stores from './stores';
import 'sanitize.css';
import './index.scss';
import 'react-select/dist/react-select.css';
import Shell from 'containers/Shell/Shell';
//import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
  <Provider {...stores}>
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.jsx